// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Karla:400,700);"]);
// Module
exports.push([module.id, "label {\n  min-height: 45px;\n}", ""]);
// Exports
module.exports = exports;
